<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
        color="blue accent-3"
        dark
        extended
        flat
        class="toolbar__fixed"
      >
      </v-toolbar>
      <v-dialog
        v-model="editDialog"
        persistent
        transition="dialog-transition"
        max-width="500px"
        v-if="editDialog"
      >
        <v-card class="pa-0">
          <v-card-title class="pa-0">
            <h3>Úprava fixace</h3>
          </v-card-title>
          <v-card-text class="pa-0 mt-3">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              class="elevation-0 ml-2 mr-2 table-no-white-space"
            >
              <template slot="items" slot-scope="props">
                <td>Název produktu</td>
                <td class="text-xs-center">
                  <v-text-field
                    style="width: 130px"
                    class="center-block"
                    suffix="Kč"
                  ></v-text-field>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions class="mt-3 pa-0">
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-3" depressed class="bold" @click="editDialog=false">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null"
                                 class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="problem==null">{{ aktualni_stav }}</h3>
            <h3 v-else class="mb-3 mt-3 red--text">{{ problem }}</h3>

            <p class="mt-2 mb-2" v-if="problem_error==null">{{ problem_error }}</p>
            <p class="mt-2 mb-2" v-if="problem_stack==null">{{ problem_stack }}</p>
          </v-card-text>
        </v-card>
      </v-dialog>

      <SporiciProgramDialog v-if="sporici_program_id!=null" :klient="klient_id.toString()"
                            :id="sporici_program_id.toString()"
                            @close="sporici_program_id=null;"></SporiciProgramDialog>
      <JednorazovyNakupDialog v-if="jednorazovy_nakup_id!=null" :klient="klient_id.toString()"
                              :id="jednorazovy_nakup_id.toString()"
                              @close="jednorazovy_nakup_id=null;"></JednorazovyNakupDialog>

      <v-card flat
              class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <h4 v-if="fixace!=null" class="ml-3">Fixace ke dni {{ fixace.datum | formatDate }}</h4>
            <v-card class="mb-5" color="">
              <v-card class="mb-5 pb-3" color="">
                <v-toolbar color="transparent" class="elevation-0">
                  <h2>Platby</h2>
                  <v-spacer></v-spacer>
                  <v-toolbar-items>
                    <v-switch label="Zobrazit detaily" v-model="platbyDetail" class="ml-3 mt-3"></v-switch>
                  </v-toolbar-items>
                </v-toolbar>
                <v-layout row wrap class="mb-2 mx-2 pl-1">
                  <v-flex xs12>
                    Počet plateb: {{ platbyItems.length }}
                  </v-flex>
                </v-layout>
                <v-data-table
                  :headers="platbyHeaders"
                  :items="platbyItems"
                  :loading="platbyLoading"
                  hide-actions
                  class="mt-3 elevation-2 ml-2 mr-2 table-top-border table-no-white-space"
                  v-if="!platbyLoading"
                  :expand="true"
                  ref="platbyTable"
                >
                  <template slot="items" slot-scope="props">
                    <tr class="transparent">
                      <td>
                        <v-checkbox
                          v-model="props.item.zpracovat"
                          primary
                          hide-details
                          @change="zpracovatPlatbu(props.item)"
                          v-if="!props.item.saving"
                        ></v-checkbox>
                        <v-progress-circular indeterminate v-else size="20" color="blue"></v-progress-circular>
                      </td>
                      <td class="pt-3 pb-3 subheading">{{ props.item.id }}</td>
                      <td class="pt-3 pb-3 subheading">{{ props.item.datum | formatDate }}</td>
                      <td class="pt-3 pb-3 subheading">
                        <router-link v-if="props.item.osoba!=null" :to="{ path: '/klienti/' + props.item.osoba.id }"
                                     target="_blank">
                          {{ props.item.osoba.nazev_osoby }}
                        </router-link>
                      </td>
                      <td class="pt-3 pb-3 subheading">
                        <span v-if="props.item.ucel_platby=='sporeni'">Spoření</span>
                        <span v-else-if="props.item.ucel_platby=='jednorazovy_nakup'">Jednorázový nákup</span>
                        <span v-else-if="props.item.ucel_platby=='elektronicka_penezenka'">Elektronická peněženka</span>
                      </td>
                      <td class="pt-3 pb-3 subheading">{{ props.item.variabilni_symbol }}</td>
                      <td class="pt-3 pb-3 subheading">{{ props.item.protiucet }}</td>
                      <td class="pt-3 pb-3 subheading text-xs-right no_wrap">
                        {{ props.item.castka | formatMoney }}{{ props.item.mena.zkratka }}
                      </td>
                      <td class="pt-3 pb-3 subheading">{{ props.item.poznamka }}</td>
                      <td class="pt-3 pb-3 subheading">
                        <v-layout row>
                          <v-flex grow>
                            <v-btn color="primary" small flat
                                   @click="klient_id=props.item.osoba.id;sporici_program_id=props.item.sporici_program.id;"
                                   v-if="props.item.osoba!=null && props.item.ucel_platby=='sporeni'" class="ml-0">
                              {{ props.item.sporici_program.nazev_sporeni }}
                            </v-btn>
                            <v-btn color="primary" small flat class="ml-0"
                                   @click="klient_id=props.item.osoba.id;jednorazovy_nakup_id=props.item.jednorazovy_nakup.id;"
                                   v-if="props.item.osoba!=null && props.item.ucel_platby=='jednorazovy_nakup'">
                              {{ props.item.jednorazovy_nakup.variabilni_symbol }}
                            </v-btn>
                          </v-flex>
                          <v-flex shrink class="pt-1">
                            <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/sporici-programy' }"
                                         target="_blank"
                                         v-if="props.item.osoba!=null && props.item.ucel_platby=='sporeni'">
                              <v-icon small>open_in_new</v-icon>
                            </router-link>
                            <router-link :to="{ path: '/klienti/' + props.item.osoba.id + '/jednorazove-nakupy' }"
                                         target="_blank"
                                         v-if="props.item.osoba!=null && props.item.ucel_platby=='jednorazovy_nakup'">
                              <v-icon small>open_in_new</v-icon>
                            </router-link>
                          </v-flex>
                        </v-layout>
                      </td>
                      <td class="pt-3 pb-3 subheading"
                          v-if="props.item.osoba!=null && props.item.ucel_platby=='sporeni'">
                        <template v-for="p in props.item.konto_pohyb">
                          <v-layout row wrap>
                            <v-flex grow>
                              <router-link :to="{ path: '/produkty/' + p.id }" target="_blank">
                                {{ p.nazev }}
                              </router-link>
                            </v-flex>
                            <v-flex shrink class="text-xs-right">
                              <span>{{ p.pocet_g | formatMoney }} g</span>
                            </v-flex>
                          </v-layout>
                        </template>
                      </td>
                      <td class="pt-3 pb-3 subheading" v-else>
                      </td>
                      <td class="text-xs-center">
                        <!-- <v-btn class="ma-0 black--text" color="primary lighten-4" icon small fab @click="editDialog=true"><v-icon>attach_money</v-icon></v-btn> -->
                      </td>
                    </tr>
                  </template>
                  <template slot="expand" slot-scope="props">
                    <v-card class="grey lighten-4 mt-1 ml-4 mb-4 mr-4 intersect no__radius" v-if="props.item.zpracovat">
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <div :class="{ 'mr-4': $vuetify.breakpoint.smAndUp }">
                              <h4 class="ml-3 mt-2">Pohyby na elektronické peněžence:</h4>
                              <v-data-table
                                :headers="platbyPenezenkaHeaders"
                                :items="props.item.elektronicka_penezenka"
                                hide-actions
                                class="mt-2 transparent--table"
                                hide-headers
                              >
                                <template slot="items" slot-scope="props">
                                  <tr class="transparent">
                                    <td class="pl-3 subheading">{{ props.item.popis }}</td>
                                    <td class="subheading text-xs-right">{{ props.item.castka | formatMoney }}
                                      {{ props.item.mena.zkratka }}
                                    </td>
                                  </tr>
                                </template>
                              </v-data-table>

                              <!-- <h4 class="ml-3 mt-2">Jiné úpravy:</h4>
                              <v-data-table
                                :headers="platbyPenezenkaHeaders"
                                :items="props.item.elektronicka_penezenka"
                                hide-actions
                                class="mt-2 transparent--table"
                                hide-headers
                              >
                                <template slot="items" slot-scope="props">
                                  <tr class="transparent">
                                    <td class="pl-3 subheading">{{props.item.popis}}</td>
                                    <td class="subheading text-xs-right">{{props.item.castka | formatMoney}} {{props.item.mena.zkratka}}</td>
                                  </tr>
                                </template>
                              </v-data-table> -->
                            </div>
                            <div :class="{ 'mr-4': $vuetify.breakpoint.smAndUp }"
                                 v-if="props.item.pohledavky != null && props.item.pohledavky.length > 0">
                              <h4 class="ml-3 mt-2">Vzniklé pohledávky:</h4>
                              <v-data-table
                                :items="props.item.pohledavky"
                                hide-actions
                                class="mt-2 transparent--table"
                                hide-headers
                              >
                                <template slot="items" slot-scope="props">
                                  <tr class="transparent">
                                    <td class="pl-3 subheading">Pohledávka</td>
                                    <td class="subheading text-xs-right">{{ props.item.castka | formatMoney }} Kč</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </div>
                          </v-flex>
                          <v-flex xs12 sm6
                                  v-if="props.item.ucel_platby=='sporeni' || props.item.ucel_platby=='jednorazovy_nakup'">
                            <div :class="{ 'ml-4': $vuetify.breakpoint.smAndUp }">
                              <h4 class="ml-3 mt-2">Provize spolupracovníkům:</h4>
                              <v-data-table
                                :headers="platbyProvizeHeaders"
                                :items="props.item.provize"
                                hide-actions
                                class="mt-2 transparent--table"
                                hide-headers
                              >
                                <template slot="items" slot-scope="props">
                                  <tr class="transparent">
                                    <td class="pl-3 subheading">
                                      <router-link :to="{ path: '/spolupracovnici/' + props.item.spolupracovnik.id }"
                                                   target="_blank">
                                        {{ props.item.spolupracovnik.nazev_osoby }}
                                      </router-link>
                                    </td>
                                    <td class="subheading text-xs-right"><span
                                      v-if="!props.item.tipar">Pozice: {{ props.item.pozice }}</span><span
                                      v-else>Tipař</span><span v-if="props.item.ma_kancelar">, Kancelář</span></td>
                                    <td class="subheading text-xs-right">{{ props.item.kredity | formatMoney }} kr.</td>
                                    <td class="subheading text-xs-right">{{ props.item.castka | formatMoney }} Kč</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                    </v-card>
                    <v-card class="grey lighten-4 mt-1 ml-4 mb-4 mr-4 intersect no__radius" v-else>
                      <v-card-text>
                        <p class="ma-2 subheading red--text darken-3">Platba nebude zpracována v této fixaci.</p>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
              <h3 class="ml-2 mr-2" v-if="bonusove_kovy.length > 0">Bonusové kovy k připsání</h3>
              <v-data-table
                :headers="bonusoveKovyHeaders"
                :items="bonusove_kovy"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2 mb-5"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="pl-3 subheading">
                      <router-link :to="{ path: '/klienti/' + props.item.osoba_id }" target="_blank">
                        {{ props.item.nazev_osoby }}
                      </router-link>
                    </td>
                    <td class="pl-3 subheading">
                      {{ props.item.nazev_sporeni }}
                    </td>
                    <td class="pl-3 subheading text-xs-right">
                      {{ props.item.mesicni_platba | formatDouble }} Kč
                    </td>
                    <td class="pl-3 subheading text-xs-right">
                      {{ props.item.zaplaceno | formatDouble }} Kč
                    </td>
                    <td class="pl-3 subheading">
                      <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt_id }" target="_blank">
                        {{ props.item.cilovy_produkt_nazev }}
                      </router-link>
                    </td>
                    <td class="subheading text-xs-right">{{ props.item.bonusovy_kov | formatDouble }} g</td>
                  </tr>
                </template>
              </v-data-table>
              <h3 class="ml-2 mr-2" v-if="bonusove_kovy.length > 0">Bonusové kovy k připsání (seskupeno)</h3>
              <v-data-table
                :headers="bonusoveKovySeskupeneHeaders"
                :items="bonusove_kovy_seskupene"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2 mb-5"
              >
                <template slot="items" slot-scope="props">
                  <tr>
                    <td class="pl-3 subheading">
                      {{ props.item.material }}
                    </td>
                    <td class="pl-3 subheading">
                      {{ props.item.kategorie }}
                    </td>
                    <td class="subheading text-xs-right">{{ props.item.bonusovy_kov | formatDouble }} g</td>
                  </tr>
                </template>
              </v-data-table>
              <h3 class="ml-2 mr-2">Gramy produktů ve fixaci:</h3>
              <v-data-table
                :headers="seskupeneProduktyHeaders"
                :items="seskupeneProdukty"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template slot="items" slot-scope="props">
                  <tr class="transparent">
                    <td class="pl-3 subheading">
                      <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                        {{ props.item.produkt.nazev }}
                      </router-link>
                    </td>
                    <td class="subheading text-xs-right">{{ props.item.g | formatDouble }}</td>
                    <td class="subheading text-xs-right">{{ props.item.pocet | formatDouble }}</td>
                  </tr>
                </template>
              </v-data-table>
              <h3 class="ml-2 mr-2 mt-5">Produkty z jednorázových objednávek ve fixaci:</h3>
              <v-data-table
                :headers="seskupeneJednorazoveProduktyHeaders"
                :items="seskupeneJednorazoveProdukty"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template slot="items" slot-scope="props">
                  <tr class="transparent">
                    <td class="pl-3 subheading">
                      <router-link :to="{ path: '/produkty/' + props.item.produkt.id }" target="_blank">
                        {{ props.item.produkt.nazev }}
                      </router-link>
                    </td>
                    <td class="subheading text-xs-right">{{ props.item.pocet | formatInt }} ks</td>
                  </tr>
                </template>
              </v-data-table>

              <!-- <h3 class="ml-2 mr-2 mt-5">Zlato - postupný nákup</h3>
              <v-data-table
                :headers="zlatoStribroHeaders"
                :items="zlatoItems"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template slot="items" slot-scope="props">
                  <tr class="transparent">
                    <td class="subheading text-xs-right">{{props.item.nazev}}</td>
                    <td class="subheading text-xs-right">{{props.item.gramy}} g</td>
                    <td class="subheading text-xs-right">{{props.item.bez_dph | formatInt}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.dph | formatInt}} Kč</td>
                  </tr>
                  <tr>
                    <td>Celkem</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_gramy}}</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_bez_dph | formatInt}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_dph | formatInt}} Kč</td>
                  </tr>
                </template>
              </v-data-table>
              <p class="mt-3 ml-2">Poplatek do zlata: <strong>2 500 Kč</strong></p>

              <h3 class="ml-2 mr-2 mt-5">Stříbro - postupný nákup</h3>
              <v-data-table
                :headers="zlatoStribroHeaders"
                :items="stribroItems"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template slot="items" slot-scope="props">
                  <tr class="transparent">
                    <td class="subheading text-xs-right">{{props.item.nazev}}</td>
                    <td class="subheading text-xs-right">{{props.item.gramy}} g</td>
                    <td class="subheading text-xs-right">{{props.item.bez_dph | formatInt}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.dph | formatInt}} Kč</td>
                  </tr>
                  <tr>
                    <td>Celkem</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_gramy}} g</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_bez_dph | formatInt}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_dph | formatInt}} Kč</td>
                  </tr>
                </template>
              </v-data-table>
              <p class="mt-3 ml-2">Poplatek do stříbra: <strong>2 500 Kč bez DPH</strong> | DPH: <strong>200 Kč</strong></p>

              <h3 class="ml-2 mr-2 mt-5">Jednorázové nákupy</h3>
              <v-data-table
                :headers="jednorazoveNakupyHeaders"
                :items="stribroItems"
                hide-actions
                class="mt-2 elevation-2 ml-2 mr-2"
              >
                <template slot="items" slot-scope="props">
                  <tr class="transparent">
                    <td class="subheading text-xs-right">{{props.item.nazev}}</td>
                    <td class="subheading text-xs-right">{{props.item.kusy}} ks</td>
                    <td class="subheading text-xs-right">{{props.item.sleva}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.dph | formatInt}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.nakup | formatInt}} Kč</td>
                  </tr>
                  <tr>
                    <td>Celkem</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_ks}} ks</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_sleva}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_dph}} Kč</td>
                    <td class="subheading text-xs-right">{{props.item.celkem_nakup}} Kč</td>
                  </tr>
                </template>
              </v-data-table> -->

              <!-- Souhrn spoření (Zlato/Stříbro) -->
              <h3 class="ml-2 mr-2 mt-5">Souhrn spoření</h3>
              <div class="summary__wrapper">
                <v-alert
                  v-if="souctyError"
                  type="error"
                  outline
                  class="ml-4 mr-4 mt-2"
                >{{ souctyError }}
                </v-alert>

                <v-skeleton-loader
                  v-if="souctyLoading"
                  type="table"
                  class="ml-4 mr-4 mt-2"
                />

                <v-data-table
                  v-else
                  :headers="[
      { text:'Kov', value:'kov' },
      { text:'Součet', value:'soucet', align: 'right' }
    ]"
                  :items="[
      { kov:'Zlato',   soucet: souctySporeni.zlato },
      { kov:'Stříbro', soucet: souctySporeni.stribro }
    ]"
                  hide-actions
                  class="mt-2 elevation-2 ml-2 mr-2"
                >
                  <template v-slot:items="props">
                    <td>{{ props.item.kov }}</td>
                    <td class="text-xs-right">
                      {{ formatCZK(props.item.soucet) }}
                    </td>
                  </template>
                </v-data-table>
                <div class="mb-2">
                  <v-btn color="blue" medium dark @click="fetchSouctySporeni(fixace ? fixace.id : null)">
                    Obnovit součty
                  </v-btn>
                </div>
              </div>


              <div class="text-xs-center mt-5 mb-2" v-if="!platbyLoading">
                <v-btn color="orange" large dark @click="loadPlatby" depressed v-if="aktualizovat">
                  <v-icon class="mr-3">refresh</v-icon>
                  Přepočítat
                </v-btn>
                <v-btn color="green" large dark @click="dokoncitFixaci" depressed v-if="!aktualizovat">
                  Fixovat
                </v-btn>
              </div>
            </v-card>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
import SporiciProgramDialog from '../Klienti/SporiciProgramDialog'
import JednorazovyNakupDialog from '../Klienti/JednorazovyNakupDialog'

export default {
  extends: Base,
  data() {
    return {
      dialog: false,
      editDialog: false,
      headers: [
        {text: 'Název produktu', value: 'nazev', sortable: false},
        {text: 'Cena', value: 'cena', align: 'center', sortable: false}
      ],
      items: [
        {
          nazev: 'Název produktu',
          cena: ' 1000 Kč'
        }
      ],
      loading: true,
      fixace: null,
      aktualni_stav: "",
      problem: null,
      slitkyHeaders: [],
      slitkyItems: [],
      platbyHeaders: [
        {text: '', value: 'id', sortable: false},
        {text: 'ID', value: 'id', sortable: false},
        {text: 'Datum', value: 'datum', sortable: false},
        {text: 'Osoba', value: 'osoba.nazev_osoby', sortable: false},
        {text: 'Účel platby', value: 'ucel_platby', sortable: false},
        {text: 'Variabilní symbol', value: 'variabilni_symbol', sortable: false},
        {text: 'Protiúčet', value: 'protiucet', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false, width: '150px'},
        {text: 'Poznámka', value: 'poznamka', sortable: false},
        {text: 'Použití na', value: 'sporici_program.nazev_sporeni', sortable: false, align: 'center'},
        {text: 'Cílový produkt', value: 'sporici_program.cilovy_produkt.nazev', sortable: false},
        {text: 'Upravit cenu', value: 'upravit_fixaci', sortable: false}
      ],
      platbyItems: [],
      platbyPenezenkaHeaders: [
        {text: 'Popis', value: 'popis', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false}
      ],
      platbyProvizeHeaders: [
        {text: 'Spolupracovník', value: 'spolupracovnik.nazev_osoby', sortable: false},
        {text: 'Pozice', value: 'pozice', sortable: false},
        {text: 'Kredity', value: 'kredity', align: 'right', sortable: false},
        {text: 'Částka', value: 'castka', align: 'right', sortable: false}
      ],
      seskupeneProduktyHeaders: [
        {text: 'Produkt', value: 'produkt.nazev', sortable: false},
        {text: 'Počet gramů', value: 'g', sortable: false, width: 200, align: "right"},
        {text: 'Počet kusů', value: 'pocet', sortable: false, width: 200, align: "right"}
      ],
      seskupeneJednorazoveProduktyHeaders: [
        {text: 'Produkt', value: 'produkt.nazev', sortable: false},
        {text: 'Počet kusů', value: 'pocet', sortable: false, width: 200, align: "right"}
      ],
      zlatoStribroHeaders: [
        {text: 'Název produktu', value: 'nazev', sortable: false},
        {text: 'Gramy', value: 'gramy', sortable: false},
        {text: 'Kč bez DPH', value: 'bez_dph', sortable: false},
        {text: 'DPH/celkem', value: 'dph', sortable: false, align: "right"}
      ],
      jednorazoveNakupyHeaders: [
        {text: 'Název produktu', value: 'nazev', sortable: false},
        {text: 'Ks', value: 'kusy', sortable: false},
        {text: 'Sleva na MJ', value: 'sleva', sortable: false},
        {text: 'DPH/nákup', value: 'dph', sortable: false},
        {text: 'Kč/celkem', value: 'nakup', sortable: false, align: "right"}
      ],
      bonusoveKovyHeaders: [
        {text: 'Klient', value: 'nazev_osoby', sortable: false},
        {text: 'Spoření', value: 'nazev_sporeni', sortable: false},
        {text: 'Měsíční platba', value: 'mesicni_platba', align: 'right', sortable: false},
        {text: 'Zaplaceno', value: 'zaplaceno', align: 'right', sortable: false},
        {text: 'Cílový produkt', value: 'cilovy_produkt_nazev', align: 'left', sortable: false},
        {text: 'Bonusový kov (g)', value: 'bonusovy_kov', align: 'right', sortable: false}
      ],
      bonusoveKovySeskupeneHeaders: [
        {text: 'Materiál', value: 'material', sortable: false},
        {text: 'Kategorie', value: 'kategorie', sortable: false},
        {text: 'Bonusový kov (g)', value: 'bonusovy_kov', align: 'right', sortable: false}
      ],
      platbyLoading: false,
      platbyDetail: true,
      seskupeneProdukty: [],
      seskupeneJednorazoveProdukty: [],
      aktualizovat: false,
      problem_error: null,
      problem_stack: null,
      klient_id: null,
      sporici_program_id: null,
      jednorazovy_nakup_id: null,
      bonusove_kovy: [],
      bonusove_kovy_seskupene: [],
      souctySporeni: {zlato: 0, stribro: 0},
      souctyLoading: false,
      souctyError: null,
    }
  },
  watch: {
    platbyDetail(v) {
      for (let i = 0; i < this.platbyItems.length; i += 1) {
        const item = this.platbyItems[i];
        this.$set(this.$refs.platbyTable.expanded, item.id, v);
      }
    }
  },
  props: {
    id: String
  },
  mounted: function () {
    window.MenuListener.show();
    this.loadFixace();
  },
  methods: {
    loadFixace() {
      this.loading = true;
      window.API.get("fixace/aktualni").then((b) => {
        this.loading = false;
        if (b.aktualni == null) {
          this.$router.push({path: "/fixace"});
        } else {
          this.fixace = b.aktualni;
          this.loadPlatby();
          this.fetchSouctySporeni(this.fixace ? this.fixace.id : null);
        }
      }).catch((e) => {
        console.log(e);
      })
    },
    zpracovatPlatbu(p) {
      this.dialog = true;
      this.aktualni_stav = "Ukládám změnu položek";
      this.problem = null;
      //this.platbyLoading = true;
      setTimeout(() => {
        window.API.post("fixace/zpracovat", {
          platba: p.id,
          zpracovat: p.zpracovat
        }).then((b) => {

          if (b.success) {

            this.aktualizovat = true;
            this.dialog = false;

          } else {
            this.problem = "Platba nemohla být změněna.";
          }


        }).catch((e) => {
          //this.problem = "Fixování cen produktů nemohlo být dokončeno.";
          //console.log(e);
        })
      }, 200);
    },
    loadPlatby() {
      this.dialog = true;
      this.aktualni_stav = "Počítám platby";
      this.problem = null;
      this.platbyLoading = true;
      window.API.get("fixace/platby").then((b) => {
        this.platbyLoading = false;
        this.dialog = false;
        this.platbyItems = b.platby.map(function (e) {
          e.saving = false;
          return e;
        });
        this.seskupeneProdukty = b.produkty;
        this.seskupeneJednorazoveProdukty = b.jednorazove;
        this.aktualizovat = false;
        this.bonusove_kovy = b.bonusove_kovy;
        this.bonusove_kovy_seskupene = b.bonusove_kovy_seskupene;

        this.fetchSouctySporeni(this.fixace ? this.fixace.id : null);

        this.$nextTick(() => {
          for (let i = 0; i < this.platbyItems.length; i += 1) {
            const item = this.platbyItems[i];
            this.$set(this.$refs.platbyTable.expanded, item.id, true);
          }
        });
      }).catch((e) => {
        console.log(e);
        this.problem = "Při počítání plateb nastala chyba.";
      })
    },
    async fetchSouctySporeni(fixaceId = null) {
      this.souctyLoading = true;
      this.souctyError = null;
      try {
        let url = "fixace/soucty-sporeni";
        if (fixaceId) url = `fixace/${fixaceId}/soucty-sporeni`;

        const resp = await window.API.get(url);
        this.souctySporeni = Object.assign({zlato: 0, stribro: 0}, resp || {});
      } catch (e) {
        console.error(e);
        this.souctyError = "Nepodařilo se načíst součty spoření.";
        this.souctySporeni = {zlato: 0, stribro: 0};
      } finally {
        this.souctyLoading = false;
      }
    },

    formatCZK(v) {
      if (typeof v !== "number") v = Number(v) || 0;
      return new Intl.NumberFormat("cs-CZ", {style: "currency", currency: "CZK", maximumFractionDigits: 2}).format(v);
    },
    dokoncitFixaci() {
      this.dialog = true;
      this.aktualni_stav = "Dokončuji fixaci";
      this.problem = null;
      window.API.get("fixace/finale").then((b) => {
        if (b.success) {
          this.dialog = false;
          this.$router.push({path: "/fixace"});
        } else {
          this.problem = "Dokončení fixace nemohlo být provedeno.";
          this.problem_detail = b.problem;
          this.problem_error = typeof b.message != "undefined" ? b.message : null;
          this.problem_stack = typeof b.stack != "undefined" ? b.stack : null;
        }
      }).catch((e) => {
        this.problem = "Dokončení fixace nemohlo být provedeno.";
        console.log(e);
      })
    }
  },
  components: {
    SporiciProgramDialog, JednorazovyNakupDialog
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Fixace/FixacePruvodce.vue